import React, { useState, useEffect } from "react";
import REVOLUTION_LEARNING_BG from "../../assets/revolution_learning_bg.png";
import { LANDING_PAGE_REVOLUTION_LEARNING_YT_VIDEO } from "../../constants/video_constants";
import SectionHeading from "./SectionHeading";
import { LANDING_PAGE_REVOLUTION } from "../../constants/text_constants";
import DOWNLOAD_ICON from "../../assets/DownLoadIcon.png";
import { TOP_FOOTER } from "../../constants/text_constants";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const RevolutionLearning = () => {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const isSideBarOpen = useSelector((store) => store.sidebar.isSideBarOpen);

  useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isDesktop = window.innerWidth >= 768; // Check screen width
  return (
    <div
      style={{
        backgroundImage: `linear-gradient(to right, rgba(34, 211, 238, 0.8), rgba(147, 51, 234, 0.8)), url(${REVOLUTION_LEARNING_BG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "DM Sans",
      }}
      className="md:rounded-xl flex flex-col items-center my-5 lg:h-[33rem] h-[41rem] lg:-mx-0 -mx-[1rem]"
    >
      <div className="flex justify-center items-center">
        <SectionHeading heading={LANDING_PAGE_REVOLUTION?.heading} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center justify-center bg-white p-5 rounded-lg gap-5 mx-5 lg:mx-12 mt-2 lg:mt-5">
  <div className="w-full flex justify-center">
    <div className="p-2 shadow-lg w-full max-w-[560px]">
      <LANDING_PAGE_REVOLUTION_LEARNING_YT_VIDEO width="100%" />
    </div>
  </div>

  <div className="md:text-sm text-xs flex flex-col gap-5 w-full">
    <div>{LANDING_PAGE_REVOLUTION?.desc1}</div>
    <div>{LANDING_PAGE_REVOLUTION?.desc2}</div>
    <Link to={TOP_FOOTER?.playStoreLink} target="_blank">
      <div className="flex items-center justify-center lg:justify-start">
        <button className="px-5 py-2 text-base font-bold text-white bg-gradient-to-r from-cyan-400 to-purple-600 rounded-full shadow-lg hover:-translate-y-1 hover:shadow-2xl transition-all">
          <div className="drop-shadow-md flex items-center gap-2">
            {LANDING_PAGE_REVOLUTION?.buttonText}
            <img alt="download-icon" src={DOWNLOAD_ICON} loading="lazy" />
          </div>
        </button>
      </div>
    </Link>
  </div>
</div>

    </div>
  );
};

export default RevolutionLearning;
